$(document).ready(function () {
  var mobileQuery = window.matchMedia("(max-width: 766px)");
  var anniversaryMobileInitialized = false;

  function initAnniversaryMobilePicker() {
    if (anniversaryMobileInitialized) return;
    anniversaryMobileInitialized = true;

    if (typeof selectedVariants === "undefined") {
      window.selectedVariants = {};
    }

    function getPickerForm() {
      var $submitBtn = $(".product-form__submit").first();
      var $form = $submitBtn.closest("form[action*='/cart/add']");

      if (!$form.length) {
        $form = $("form[action*='/cart/add']").first();
      }

      return $form;
    }

    function getActivePickers() {
      var $visiblePickers = $(".custom-choose-product:visible");

      if ($visiblePickers.length) {
        return $visiblePickers;
      }

      return $(".custom-choose-product");
    }

    function getPickerNumber($picker) {
      var id = $picker.attr("id") || "";
      var match = id.match(/(\d+)$/);

      if (match) {
        return match[1];
      }

      return $picker.index(".custom-choose-product") + 1;
    }

    function getPickerKey($picker) {
      var pickerNumber = getPickerNumber($picker);
      return "product" + pickerNumber;
    }

    function getOptionData($option) {
      var productId = $option.attr("data-product-id") || "";
      var productHandle = $option.attr("data-handle") || "";
      var productHandleColor = $option.attr("data-handle-color") || "";
      var productTitle = $option.attr("data-product-title") || "";
      var productImage = $option.attr("data-product-image") || "";

      if (!productTitle) {
        productTitle =
          $.trim($option.find(".option-label").text()) ||
          $.trim($option.text()) ||
          "";
      }

      if (!productImage) {
        productImage = $option.find("img").attr("src") || "";
      }

      return {
        productId: String(productId),
        productHandle: productHandle,
        productHandleColor: productHandleColor,
        productTitle: productTitle,
        productImage: productImage
      };
    }

    function isUniqueSelectionProductId(productId) {
      productId = $.trim(String(productId || ""));

      if (!productId) return false;

      return (
        $('.custom-choose-product .option-products-wrapper[data-product-id="' + productId + '"][data-unique-selection="true"]').length > 0
      );
    }

    function getSelectedUniqueProductIds($exceptPicker) {
      var selectedIds = [];

      getActivePickers().each(function () {
        var $picker = $(this);

        if ($exceptPicker && $picker.is($exceptPicker)) return;

        var productId = $.trim($picker.attr("data-product-id") || "");

        if (
          productId &&
          isUniqueSelectionProductId(productId) &&
          selectedIds.indexOf(productId) === -1
        ) {
          selectedIds.push(productId);
        }
      });

      return selectedIds;
    }

    function prepareDuplicateOptionState() {
      $(".custom-choose-product .option-products-wrapper").each(function () {
        var $option = $(this);

        if (typeof $option.attr("data-original-disabled") === "undefined") {
          $option.attr("data-original-disabled", $option.hasClass("disabled") ? "true" : "false");
        }
      });
    }

    function syncDuplicateProductOptions() {
      prepareDuplicateOptionState();

      getActivePickers().each(function () {
        var $picker = $(this);
        var selectedUniqueInOtherPickers = getSelectedUniqueProductIds($picker);
        var hasUniqueSelectionInOtherPicker = selectedUniqueInOtherPickers.length > 0;

        $picker.find(".option-products-wrapper").each(function () {
          var $option = $(this);
          var isOriginallyDisabled = $option.attr("data-original-disabled") === "true";
          var isUniqueSelectionOption = $option.attr("data-unique-selection") === "true";
          var shouldBlockUniqueOption = isUniqueSelectionOption && hasUniqueSelectionInOtherPicker;

          if (isOriginallyDisabled || shouldBlockUniqueOption) {
            $option.addClass("disabled");

            if (shouldBlockUniqueOption) {
              $option.attr("data-selected-in-other-picker", "true");
            } else {
              $option.removeAttr("data-selected-in-other-picker");
            }
          } else {
            $option.removeClass("disabled");
            $option.removeAttr("data-selected-in-other-picker");
          }
        });
      });
    }

    function updateSelectedCategoryUI($picker, $option, data) {
      var $categoryWrapper = $picker.find(".selected-category-wrapper");

      if (!$categoryWrapper.length) return;

      var $optionCategory = $option.find(".selected-category").first();

      if ($optionCategory.length) {
        $categoryWrapper.html($optionCategory.clone()).show();
        return;
      }

      if (data.productHandle) {
        var colorStyle = data.productHandleColor
          ? ' style="color:' + data.productHandleColor + ';"'
          : "";

        $categoryWrapper
          .html(
            '<div class="selected-category"' +
              colorStyle +
              ">" +
              data.productHandle +
              "</div>"
          )
          .show();
      } else {
        $categoryWrapper.html("").hide();
      }
    }

    function updateSelectedPickerUI($picker, $option, data) {
      $picker
        .attr("data-product-id", data.productId)
        .attr("data-handle", data.productHandle)
        .attr("data-handle-color", data.productHandleColor)
        .attr("data-product-title", data.productTitle)
        .attr("data-product-image", data.productImage);

      $picker.find(".selected-label").text(data.productTitle);

      if (data.productImage) {
        $picker.find(".selected-image").html(
          '<img src="' +
            data.productImage +
            '" alt="' +
            data.productTitle +
            '" loading="lazy">'
        );
      } else {
        $picker.find(".selected-image").html("");
      }

      updateSelectedCategoryUI($picker, $option, data);

      $picker
        .find(".selected-products-wrapper")
        .addClass("selected-products-wrapper-updated");
    }

    function isPickerAlreadyFilled($picker) {
      var productId = $.trim($picker.attr("data-product-id") || "");
      var productTitle = $.trim($picker.attr("data-product-title") || "");

      var selectedLabel = $.trim($picker.find(".selected-label").text() || "");
      var selectedImage = $.trim(
        $picker.find(".selected-image img").attr("src") || ""
      );

      var hasActiveOption =
        $picker.find(".option-products-wrapper.active").length > 0;

      return (
        (productId !== "" && productTitle !== "") ||
        (selectedLabel !== "" &&
          selectedLabel.toLowerCase() !== "select product" &&
          selectedLabel.toLowerCase() !== "select") ||
        selectedImage !== "" ||
        hasActiveOption
      );
    }

    function updateSubmitButtonState() {
      var selectedCount = 0;
      var $pickers = getActivePickers();

      $pickers.each(function () {
        var $picker = $(this);

        if (isPickerAlreadyFilled($picker)) {
          selectedCount++;
        }
      });

      var $submitBtn = $(".product-form__submit");

      if (selectedCount >= 3) {
        $submitBtn
          .removeClass("disabled")
          .prop("disabled", false)
          .removeAttr("disabled");
      } else {
        $submitBtn
          .addClass("disabled")
          .prop("disabled", true)
          .attr("disabled", "disabled");
      }

      console.log("[Anniversary Mobile] Selected count:", selectedCount);
    }

    function updateAnniversaryProperties() {
      var $form = getPickerForm();

      if (!$form.length) {
        console.warn("[Anniversary Mobile] Cart form not found");
        return;
      }

      var $pickers = getActivePickers();

      $form.find(".anniversary-property-input").remove();

      $("<input>", {
        type: "hidden",
        class: "anniversary-property-input",
        name: "properties[Product Type]",
        value: "Anniversary"
      }).appendTo($form);

      $pickers.each(function () {
        var $picker = $(this);
        var itemNumber = getPickerNumber($picker);

        var productTitle = $picker.attr("data-product-title") || "";
        var productImage = $picker.attr("data-product-image") || "";
        var productId = $picker.attr("data-product-id") || "";
        var productHandle = $picker.attr("data-handle") || "";

        if (!productTitle && !productImage && !productId) return;

        $("<input>", {
          type: "hidden",
          class: "anniversary-property-input",
          name: "properties[Product Title " + itemNumber + "]",
          value: productTitle
        }).appendTo($form);

        $("<input>", {
          type: "hidden",
          class: "anniversary-property-input",
          name: "properties[Product Image " + itemNumber + "]",
          value: productImage
        }).appendTo($form);

        $("<input>", {
          type: "hidden",
          class: "anniversary-property-input",
          name: "properties[Product Category " + itemNumber + "]",
          value: productHandle
        }).appendTo($form);
      });

      $form.find(".anniversary-property-input").each(function () {
        console.log($(this).attr("name"), "=", $(this).val());
      });
    }

    window.updateAnniversaryMobileProperties = updateAnniversaryProperties;
    window.updateAnniversaryMobileSubmitState = updateSubmitButtonState;

    prepareDuplicateOptionState();
    syncDuplicateProductOptions();
    updateAnniversaryProperties();
    updateSubmitButtonState();

    setTimeout(function () {
      syncDuplicateProductOptions();
      updateAnniversaryProperties();
      updateSubmitButtonState();
    }, 500);

    $(window).on("load.anniversaryMobile", function () {
      syncDuplicateProductOptions();
      updateAnniversaryProperties();
      updateSubmitButtonState();
    });

    $(document).on(
      "click.anniversaryMobile",
      ".selected-products-wrapper",
      function (e) {
        if (!mobileQuery.matches) return;

        e.preventDefault();
        e.stopPropagation();

        var $currentWrapper = $(this);
        var $currentPicker = $currentWrapper.closest(".custom-choose-product");
        var $currentList = $currentPicker.find(".list-products-wrapper");
        var isOpen = $currentWrapper.hasClass("active");

        $(".custom-choose-product")
          .not($currentPicker)
          .find(".list-products-wrapper")
          .slideUp(150);

        $(".custom-choose-product")
          .not($currentPicker)
          .find(".selected-products-wrapper")
          .removeClass("active");

        if (isOpen) {
          $currentWrapper.removeClass("active");
          $currentList.slideUp(150);
        } else {
          syncDuplicateProductOptions();
          $currentWrapper.addClass("active");
          $currentList.slideDown(150);
        }
      }
    );

    $(document).on(
      "click.anniversaryMobile",
      ".list-products-wrapper",
      function (e) {
        if (!mobileQuery.matches) return;
        e.stopPropagation();
      }
    );

    $(document).on("click.anniversaryMobile", function () {
      if (!mobileQuery.matches) return;

      $(".list-products-wrapper").slideUp(150);
      $(".selected-products-wrapper").removeClass("active");
    });

    $(document).on(
      "click.anniversaryMobile",
      ".option-products-wrapper",
      function (e) {
        if (!mobileQuery.matches) return;

        e.preventDefault();
        e.stopPropagation();

        var $option = $(this);
        var $picker = $option.closest(".custom-choose-product");

        syncDuplicateProductOptions();

        if ($option.hasClass("disabled")) {
          return;
        }

        var key = "";

        if (typeof idToKey === "function") {
          key = idToKey($picker.attr("id"));
        }

        if (!key) {
          key = getPickerKey($picker);
        }

        var data = getOptionData($option);

        if (!data.productId) {
          console.warn("[Anniversary Mobile] Option has no product id", this);
          return;
        }

        selectedVariants[key] = data.productId;

        console.log("[Anniversary Mobile] Selected:", {
          picker_id: $picker.attr("id"),
          key: key,
          product_id: data.productId,
          product_title: data.productTitle,
          product_image: data.productImage,
          product_handle: data.productHandle,
          product_handle_color: data.productHandleColor
        });

        updateSelectedPickerUI($picker, $option, data);

        var fakeVariant = {
          title: data.productTitle,
          featured_image: {
            src: data.productImage
          }
        };

        if (typeof reflectSelectionUI === "function") {
          reflectSelectionUI($picker, null, fakeVariant);
        }

        if (key === "product1") {
          $(".custom-product-image-1").attr("src", data.productImage);
        }

        if (key === "product2") {
          $(".custom-product-image-2").attr("src", data.productImage);
        }

        if (key === "product3") {
          $(".custom-product-free-2").attr("src", data.productImage);
        }

        $picker.find(".option-products-wrapper").removeClass("active");
        $option.addClass("active");

        syncDuplicateProductOptions();

        $picker.find(".list-products-wrapper").slideUp(150);
        $picker.find(".selected-products-wrapper").removeClass("active");

        updateAnniversaryProperties();
        updateSubmitButtonState();

        if (typeof updateTotals === "function") {
          updateTotals();
        }
      }
    );
  }

  function destroyAnniversaryMobilePicker() {
    if (!anniversaryMobileInitialized) return;

    $(document).off(".anniversaryMobile");
    $(window).off(".anniversaryMobile");

    $(".list-products-wrapper").hide();
    $(".selected-products-wrapper").removeClass("active");

    anniversaryMobileInitialized = false;
  }

  function handleMobilePickerState() {
    if (mobileQuery.matches) {
      initAnniversaryMobilePicker();
    } else {
      destroyAnniversaryMobilePicker();
    }
  }

  handleMobilePickerState();

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", handleMobilePickerState);
  } else {
    mobileQuery.addListener(handleMobilePickerState);
  }
});

$(document).ready(function () {
  var productsPerRow = 2;

  function getInitialCount($countEl) {
    var initialCount = parseInt($countEl.attr("data-initial-count"), 10);

    if (!isNaN(initialCount)) {
      return initialCount;
    }

    initialCount =
      parseInt($countEl.attr("data-scroll_product_count"), 10) ||
      parseInt($countEl.attr("data-scroll-product-count"), 10) ||
      parseInt($countEl.text().replace(/[^0-9]/g, ""), 10) ||
      0;

    $countEl.attr("data-initial-count", initialCount);

    return initialCount;
  }

  function getRowHeight($wrapper) {
    var $items = $wrapper.find(".custom-choose-products-wrapper");

    if ($items.length < 2) {
      return 60;
    }

    var firstTop = $items.eq(0).position().top;
    var secondRowTop = null;

    $items.each(function () {
      var itemTop = $(this).position().top;

      if (itemTop > firstTop) {
        secondRowTop = itemTop;
        return false;
      }
    });

    if (secondRowTop !== null) {
      return secondRowTop - firstTop;
    }

    return $items.first().outerHeight(true) || 60;
  }

  function updateCountByScroll($wrapper) {
    var $container = $wrapper.closest(".custom-main-anniversary-container");
    var $overlay = $container.find(".custom-products-overlay").first();
    var $countEl = $overlay.find(".dynamic-products-counts").first();

    if (!$countEl.length) return;

    var initialCount = getInitialCount($countEl);
    var rowHeight = getRowHeight($wrapper);
    var scrollTop = $wrapper.scrollTop();

    var hiddenRows = Math.round(scrollTop / rowHeight);
    var hiddenProducts = hiddenRows * productsPerRow;

    var newCount = initialCount - hiddenProducts;

    if (newCount < 0) {
      newCount = 0;
    }

    $countEl.attr("data-scroll_product_count", newCount);
    $countEl.attr("data-scroll-product-count", newCount);
    $countEl.text(newCount > 0 ? newCount + "+" : newCount);
  }

  function bindProductScroll() {
    $(".custom-main-anniversary-container .custom-products-wrapper").each(
      function () {
        var wrapper = this;
        var $wrapper = $(wrapper);

        if ($wrapper.attr("data-count-scroll-bound") === "true") return;

        $wrapper.attr("data-count-scroll-bound", "true");

        updateCountByScroll($wrapper);

        wrapper.addEventListener(
          "scroll",
          function () {
            window.requestAnimationFrame(function () {
              updateCountByScroll($wrapper);
            });
          },
          { passive: true }
        );
      }
    );
  }

  bindProductScroll();

  $(document).on(
    "click",
    ".custom-products-overlay .custom-products-scroll-btn",
    function (e) {
      e.preventDefault();

      var $container = $(this).closest(".custom-main-anniversary-container");
      var $wrapper = $container.find(".custom-products-wrapper").first();

      if (!$wrapper.length) {
        $wrapper = $(
          ".custom-main-anniversary-container .custom-products-wrapper"
        ).first();
      }

      if (!$wrapper.length) return;

      var rowHeight = getRowHeight($wrapper);
      var scrollAmount = rowHeight * 2;

      $wrapper.stop(true).animate(
        {
          scrollTop: $wrapper.scrollTop() + scrollAmount
        },
        300,
        function () {
          updateCountByScroll($wrapper);
        }
      );
    }
  );

  $(document).on("shopify:section:load", function () {
    bindProductScroll();
  });
});